import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HomeResume.css';



const HomeResume = () => {
    return (
        <div id='resume'>
            <Container className='resume-container'>
                <div className='services-dot'>
                    <h2>My Resume</h2>
                    <h3>.</h3>
                </div>
                <p className='serv-p p-2'>A summary of My Resume</p>
                <Row>
                    <Col lg={6} md={6} sm={12}>
                        <div className='my-work p-2'>
                            <h4 className='mt-2'>My Education</h4>
                            <div className='mt-4'>
                                <div>
                                    <h5>B.Sc. in Computer Science & Engineering</h5>
                                    <h6>University of Development Alternative (UODA)</h6>
                                    <p>January 2017 - 2021</p>
                                </div>

                             <div className='mt-4'>
                                 <h5>Web Development Course</h5>
                                 <h6>Programming Hero</h6>
                                 <p>July 2021 – November 2021</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                        <div className='experience p-2'>
                            <h4 className='mt-2'>My Experience</h4>
                            <div>
                                <div className='mt-4'>
                                    <h5>Web Developer</h5>
                                    <h6>BongoDemy</h6>
                                    <p>January 2021 - March 2022</p>
                                </div>

                                <div className='mt-4'>
                                    <h5>Frontend Developer</h5>
                                    <h6>Semiclone.inc</h6>
                                    <p> 2022 – January 2023</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default HomeResume;